var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', [_vm._v("로그인 / 로그아웃")]), _c('section', {
    staticClass: "mt-4"
  }, [_c('example-layout', {
    staticClass: "overflow-auto mt-8",
    scopedSlots: _vm._u([{
      key: "render",
      fn: function fn() {
        return [_c('example-login-logout')];
      },
      proxy: true
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }